export const SUMMARY_DASHBOARD_EDIT_DIALOG_TEST_IDS = {
  addComponentButton: 'summary-dashboard-edit-dialog-add-component',
  cancelButton: 'summary-dashboard-edit-dialog-cancel',
  closeButton: 'summary-dashboard-edit-dialog-close',
  componentDeleteButton: (id: string) => `summary-dashboard-edit-dialog-delete-${id}`,
  componentRow: (id: string) => `summary-dashboard-edit-dialog-component-${id}`,
  deleteComponentButton: 'summary-dashboard-edit-dialog-delete-active',
  dialog: 'summary-dashboard-edit-dialog',
  emptyState: 'summary-dashboard-edit-dialog-empty',
  errorAlert: 'summary-dashboard-edit-dialog-errors',
  // Keyed by the descriptor's path-like key ('display.title'), not its label: labels change with
  // copy, and a label-keyed test id breaks on every wording tweak.
  field: (key: string) => `summary-dashboard-edit-dialog-field-${key}`,
  saveButton: 'summary-dashboard-edit-dialog-save',
  section: (title: string) => `summary-dashboard-edit-dialog-section-${title}`,
  tabs: 'summary-dashboard-edit-dialog-tabs',
} as const;
